import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";
import logo from "../assets/images/logo.png";
import "./Landing.css";

const Navbar = ({ onSignIn }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <header className="lm-navbar" role="banner">
      <div className="container navbar-inner">
        <Link className="brand" to="/" aria-label="AllinoneResume home">
          <img
            src={logo}
            alt="AllinoneResume logo"
            width="30"
            height="30"
            aria-hidden="true"
          />
          <span className="brand-text">AllinoneResume</span>
        </Link>

        <nav className="nav-desktop" role="navigation" aria-label="Main">
          <ul className="nav-links">
            <li>
              <Link className="nav-link" to="/edit-template">
                Create New{" "}
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/list-templates">
                Templates
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/my-resume">
                My Resume{" "}
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/notes">
                Notes
              </Link>
            </li>
          </ul>
        </nav>

        <div className="nav-actions">
          {currentUser ? (
            <>
              <span className="user-email">{currentUser.email}</span>
              <button
                className="btn btn-ghost"
                onClick={() => navigate("/settings")}
                aria-label="Settings"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button
                className="btn btn-ghost"
                onClick={handleLogout}
                aria-label="Logout"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.36 6.64a9 9 0 1 1-12.73 0"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <line
                    x1="12"
                    y1="2"
                    x2="12"
                    y2="12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </>
          ) : (
            <button
              className="btn btn-ghost"
              onClick={() => onSignIn && onSignIn()}
              aria-haspopup="dialog"
            >
              Sign in
            </button>
          )}
        </div>

        <div className="mobile-menu">
          <button
            className="mobile-toggle"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMenuOpen((s) => !s)}
          >
            <span className="sr-only">Toggle navigation</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              {menuOpen ? (
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              ) : (
                <path
                  d="M3 12H21M3 6H21M3 18H21"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-drawer" role="dialog" aria-modal="true">
          <ul>
            <li>
              <Link
                className="nav-link"
                to="/edit-template"
                onClick={() => setMenuOpen(false)}
              >
                Create New
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="/list-templates"
                onClick={() => setMenuOpen(false)}
              >
                Templates
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="/my-resume"
                onClick={() => setMenuOpen(false)}
              >
                My Resume
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="/notes"
                onClick={() => setMenuOpen(false)}
              >
                Notes
              </Link>
            </li>
            {currentUser && (
              <li>
                <Link
                  className="nav-link"
                  to="/settings"
                  onClick={() => setMenuOpen(false)}
                >
                  Settings
                </Link>
              </li>
            )}
            <li className="mobile-actions">
              {currentUser ? (
                <button
                  className="btn btn-ghost"
                  onClick={() => {
                    handleLogout();
                    setMenuOpen(false);
                  }}
                >
                  Logout
                </button>
              ) : (
                <button
                  className="btn btn-ghost"
                  onClick={() => {
                    onSignIn && onSignIn();
                    setMenuOpen(false);
                  }}
                >
                  Sign in
                </button>
              )}
              <button
                className="btn btn-gradient"
                onClick={() => {
                  navigate("/edit-template");
                  setMenuOpen(false);
                }}
              >
                Create Resume
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
